import React, { useEffect, useState } from "react";
import DeductionViewPage from "../../../../../entities/DashboardPage/HRModule/Deductions/DeductionView";
import AuthService from "../../../../../api/AuthService";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useLocation } from "react-router-dom";
import { useAlert } from "../../../../../context/AlertContext";
import { getBlobErrorMessage } from "../../../../../utils/blobError";

const DeductionView = () => {
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false);
  const { state } = useLocation();
  const { item } = state || {};
  const { showAlert } = useAlert();
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);


  useEffect(() => {
    getDeductionTransactionList("", "", page);
  }, [page])
  const getDeductionTransactionList = async (text, sort, page) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getDeductionTransaction(text, sort, page, item?._id);
      if (result?.success) {
        setData(result?.data?.deductions);
        setTotal(result?.data?.total);

        LoaderHelper.loaderStatus(false);

        // console.log(result,"result getemployee")
      } else {
        LoaderHelper.loaderStatus(false);
        // console.log(result?.message, "kjshakjh");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };


  const handleFilter = (text, sort) => {
    text ? getDeductionTransactionList(text) : sort ? getDeductionTransactionList("", sort) : null
  };


  const handleDownload = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deductionTransactionDownload(item?._id);
      if (!result) {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      } else {
        const downloadError = await getBlobErrorMessage(result);
        if (downloadError) {
          LoaderHelper.loaderStatus(false);
          showAlert(downloadError, "error");
          return;
        }
        const blob = new Blob([result], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `FileName.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleAddDeduction = async (deductionId, employeeId, amount, date, paymentMethod) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.addDeductionManualPayment(deductionId, employeeId, amount, date, paymentMethod);
      if (result?.success) {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message || "Deduction added successfully", "success");
        setOpenAddModal(false);
        getDeductionTransactionList("", "", page);
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message || "Failed to add deduction", "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert("An error occurred while adding deduction", "error");
    }
  };


  return (
    <DeductionViewPage
      page={page}
      open={open}
      setOpen={setOpen}
      handleDownload={handleDownload}
      total={total}
      setPage={setPage}
      data={data}
      handleFilter={handleFilter}
      openAddModal={openAddModal}
      setOpenAddModal={setOpenAddModal}
      handleAddDeduction={handleAddDeduction}
      item={item}
    />
  )

}

export default DeductionView;
